<template>
  <div id="scroll-threshold-example">
    <div>
      <div class="mt-5" v-if="settings">
        <v-row :class="$vuetify.breakpoint.smAndDown?'':'mx-1'">
          <v-col cols="12">
            <v-container style="max-width:900px">
                <v-row class="px-3">
                  <!--
                  <v-col cols="12" md="12">
                    <div class="text-center">
                      <v-card
                        class="neu-glow py-5"        
                      >
                        <v-img v-if="!$vuetify.theme.dark"
                          :src="'/static/users/pictures/db/'+settings.options.logoDB"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDB"
                          max-width="250"
                          class="mx-auto"
                        >
                        </v-img>
                        <v-img v-else
                          :src="'/static/users/pictures/db/'+settings.options.logoDBW"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDBW"
                          max-width="250"
                          class="mx-auto"
                        >
                        </v-img>                        
                        <div>
                          <div class="text-h6 mt-3 mb-1">{{$t(page+'.Hi')}} <span v-if="settings.firstName||settings.lastName" :class="'font-weight-bold '+settings.options.color+'--text'">{{settings.firstName?settings.firstName:settings.lastName}},</span></div>
                          <div class="text-subtitle-1 mb-3 px-3">{{$t(page+'.We reserved you')}}</div>
                        </div>
                      </v-card>
                    </div> 
                  </v-col>
                  -->
                  <v-col cols="12" v-if="!settings">
                    <v-card class="text-center neu-glow py-5">
                      <v-progress-circular indeterminate size="300" width="20" color="info"></v-progress-circular>
                    </v-card>
                  </v-col>
                  <template v-else>
                    <v-card-text>
                      <v-card class="text-h5 neu-glow text-center">
                        
                        <div class="mt-3">
                          <v-img
                            v-if="settings.origin=='ireview'"
                            :src="'https://ibookrestaurant.com/static/users/pictures/coupons/'+settings.picture"
                            :lazy-src="'https://ibookrestaurant.com/static/users/pictures/coupons/'+settings.picture"
                            class="mx-auto"
                          >
                          </v-img>
                          <v-img
                            v-else
                            :src="'https://ibookrestaurant.com/static/users/pictures/wa/'+settings.picture"
                            :lazy-src="'https://ibookrestaurant.com/static/users/pictures/wa/'+settings.picture"
                            class="mx-auto"
                          >
                          </v-img>                          
                        </div>
                      </v-card>
                    </v-card-text>
                    <v-card-text>
                      <v-card class="pa-4 neu-glow text-h6">
                        <p class="font-weight-bold text-h5">{{settings.options.brand}}</p>
                        <p>{{settings.couponText1}}</p>
                        <p>{{$t(page+'.Coupon is valid until')}} {{settings.expiry}},
                        <p v-if="settings.validDoW.length!=7">
                          {{$t(page+'.Coupon can be consumed only on')}}
                          <span v-for="(d,di) in dows.filter(d => settings.validDoW.includes(d.code))" :key="di">
                            {{d[locale].substring(0,9).toUpperCase()}}{{(di <= dows.filter(d => settings.validDoW.includes(d.code)).length-2)?',':''}}</span>, 
                        </p>
                        <p>
                            <span v-if="settings.maxCovers>0">, {{$t(page+'.and for not more than')}} {{settings.maxCovers}} {{$t(page+'.persons')}}</span>
                        </p>
                      </v-card>
                    </v-card-text>
                    <v-card-text>
                      <v-card class="pa-4 neu-glow text-center" v-if="!settings.spentDate&&!settings.expired">
                        <v-row>
                          <v-col>
                            <div class="text-h6">
                              {{$t(page+'.Show this QR Code to the waiter if requested')}}
                            </div>
                          </v-col>
                        </v-row>
                        <v-row class="text-center white theme--light">
                          <v-col class="d-flex justify-center">
                            <div class="px-4 pt-4 pb-2 white text-center" style="background: url( '/static/users/pictures/white_300_300.jpg') no-repeat center center; background-size: cover;">
                              <qrcode-vue  :value="'https://ibookrestaurant.com/validateqr/?p='+settings.couponId" :size="200" render-as="canvas" level="L" ></qrcode-vue>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-card class="pa-4 neu-glow text-center" v-else-if="settings.spentDate">
                        <v-row>
                          <v-col>
                            <div class="text-h5 warning--text">
                              {{$t(page+'.Sorry, Coupon already spent on') + '  ' + settings.spentDate}}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                      <v-card class="pa-4 neu-glow text-center" v-else>
                        <v-row>
                          <v-col>
                            <div class="text-h5 warning--text">
                              {{$t(page+'.Sorry, Coupon expired on') + '  ' + settings.expiry}}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>                                              
                    </v-card-text>
                  </template>
                </v-row>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-btn
      v-if="settings"
      v-scroll="onScroll"
      v-show="scrollToTop"
      fab
      dark
      small
      fixed
      bottom
      right
      :color="settings.options.color"
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-bottom-navigation
      color="orange"
      absolute
      hide-on-scroll
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500" 
      class="mt-3 mb-4" 
      style="position:unset"
      v-if="settings"   
    >
      <v-btn :href="settings.options.facebookURL" v-if="settings.options.facebookURL">
        <span>Facebook</span>
        <v-icon color="#3b5998">mdi-facebook</v-icon>
      </v-btn>
      <v-btn :href="settings.options.instagramURL" v-if="settings.options.instagramURL">
        <span>Instagram</span>
        <v-icon color="#C13584">mdi-instagram</v-icon>
      </v-btn>
      <v-btn :href="settings.options.youtubeURL" v-if="settings.options.youtubeURL">
        <span>YouTube</span>
        <v-icon color="#c4302b">mdi-youtube</v-icon>
      </v-btn>
      <v-btn :href="settings.options.linkedInURL" v-if="settings.options.linkedInURL">
        <span>LinkedIn</span>
        <v-icon color="#0077b5">mdi-linkedin</v-icon>
      </v-btn>      
    </v-bottom-navigation>
    <div id="scroll-threshold-example">
      &nbsp;
    </div>   
    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QrcodeVue from 'qrcode.vue'
export default {
   components: {
      QrcodeVue,
    },
  data() {
    return {
      page: "Review",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_thanks:false,
      dialog_leave_to_tripadvisor:false,
      dialog_connection_error:false,
      dialog_leave_to_tripadvisor:false,
      dialog_duplicated:false,
      loading:false,
      origin:null,
      date:null,//new Date().toISOString().substring(0,10),
      today:new Date().toISOString().substring(0,10),
      locale:'it',   
      snackbar:{active:false,color:'success',text:''},
      reviewSaved:false,
      uu:null,
      user:{},
      booking:{firstName:null,lastName:null},
      bookingId:null,
      totalScore:0,
      coupon:null,
      partialScore:0,
      review:{"food":5,"service":5,"value":5,"location":5,"review":null},
      settings:null,
      reviewPrizeValidUntil:null,
      QRCodeLink:null,
      payloads:null,
      hostname:null,
      locale:null,
      dows:[
            {code:1,it:'Lunedì',en:'Mondays'},
            {code:2,it:'Martedì',en:'Tuesdays'},
            {code:3,it:'Mercoledì',en:'Wednsdays'},
            {code:4,it:'Giovedì',en:'Thursdays'},
            {code:5,it:'Venerdì',en:'Fridays'},
            {code:6,it:'Sabato',en:'Saturdays'},
            {code:7,it:'Domenica',en:'Sundays'}
           ],      
    };
  },
  created(){
    this.$vuetify.theme.dark=true;
    //localStorage.removeItem('uu');
    sessionStorage.removeItem('jwt');
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
    this.locale=la.substring(0,2);
    this.couponId=this.$route.query.p;
    console.log(818,this.$route,this.$route.query,this.$route.query.p);
    this.origin=this.$route.path;
    console.log(347,this.origin);
    var hostname=window.location.hostname;
    this.QRCodeLink='https://'+hostname+'/qrcodevalidate/?p='+this.couponId
    this.Authenticate(this.couponId)

  },  
  mounted: function () {

  },
  computed : {
    ...mapGetters(["settings","countries"]),
  },
  watch : {
  },
  methods:
  {
    addDaysFormatted(days) {
      var result = new Date();
      result.setDate(result.getDate() + days);
      return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
    },        
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.scrollToTop = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    async Authenticate(couponId){
      this.loading=true;
      //try{
          const payload=JSON.stringify({"action":"AuthenticateCoupon","payload":{"couponId":couponId}});
          const res = await this.$http.post('/review/review.php', payload );
          console.log(1026,res);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              this.settings=res.data.payloads;
              //this.coupon=res.data.payloads;
              console.log(374,this.settings)              
            break;
            case '0001':

            break
            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading= false;
      /*} catch(e)
      {
          this.dialog_connection_error=true;
          console.error(1215,e);
      }*/
    },
  },
};
</script>
